import { Notification } from "rsuite";

const toastACI = ({ type, header, message }) => (
  <Notification type={type} header={header} closable>
    {message}
  </Notification>
);

export default toastACI;
